export const splitCamelCase = (value: string) => {
  const camelCase = value.replace(/([a-z])([A-Z])/g, '$1 $2').split(' ');
  return camelCase.map((item) => item.charAt(0).toUpperCase() + item.slice(1)).join(' ');
};
